import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/dashboard", "documento": "invoices", "acceso": "sesion", "filas": ["030"], "cita": "prod:Areas/Invoices/Controllers/DashboardController.cs:17"} satisfies RutaProd;
